<template>
  <div v-if="payments">
    <v-card class="mt-6">
      <v-card-title>
        My Payments
      </v-card-title>  
      <v-card-text>                  
        <v-data-table 
          :headers="headers" 
          :items="payments" 
          dense
          :items-per-page="-1"
          fixed-header
          height="75vh">                       
          <template v-slot:item.requestedAt="{ item }">
            <span v-if="item.requestedAt">
              {{ $dateUtils.formatDateTimeConcise(item.requestedAt) }}
            </span>
          </template>               
          <template v-slot:item.transactionAmount="{ item }">
            <span>
              ${{ item.transactionAmount }}
            </span>
          </template>            
          <template v-slot:item.paidAt="{ item }">
            <span v-if="item.paidAt">
              {{ $dateUtils.formatDateTimeConcise(item.paidAt) }}
            </span>
          </template>   
          <template v-slot:item.actionButton="{ item }">
            <router-link
              v-if="!!item.workflowGuid && !!workflowsWithDetailsAndPaymentView.find(x => x == item.workflowTypeDesc)"
              class="no-text-decoration"
              :to="`/requests/${item.workflowTypeDesc}/${item.workflowGuid}`">
              <v-btn class="mr-4"> View details</v-btn>
            </router-link>
            <router-link
              class="no-text-decoration"
              :to="`/requests/${item.workflowTypeDesc}/${item.workflowGuid}`"
              v-if="!!item.workflowGuid && !!workflowsWithDetailsAndPaymentView.find(x => x == item.workflowTypeDesc) && !item.paidAt">
              <v-btn class="mr-4"> Pay </v-btn>
            </router-link>
          </template>  
        </v-data-table>
      </v-card-text>   
    </v-card>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import personService from "@/services/portal/personService";
import { UserInfo } from "@/types/User";

export default Vue.extend({
  name: "MyPayments",
  data: function() {
    return {
      payments: Array<object>(),
      headers: [
        { text: "#ID", align: "left", value: "id", width: "50px" },
        { text: "Registration type", align: "left", value: "workflowTypeDesc", width: "160px" },
        { text: "Fee amount", align: "left", value: "transactionAmount", width: "50px" },
        { text: "Requested at", align: "left", value: "requestedAt", width: "100px" },
        { text: "Paid at", align: "left", value: "paidAt", width: "100px" },
        { text: "Payment type", align: "left", value: "paymentTypeDesc", width: "100px" },
        { text: "", align: "left", value: "actionButton", width: "200px" },
      ],
      workflowsWithDetailsAndPaymentView: [
        "KennelRegistration",
        "LitterRegistration",
        //PuppyRelease = 3,
        "LeaseRegistration",
        "AffiliateRegistration",
        "AffiliateRenewal",
        "KennelOwnersChange",
        "QTRegistration",
        "DogRegistrationIndividual",
        // LEPRegistration = 9,
        // MemberRegistration = 10,
        // MemberRenewal = 11,
        // MemberAussieRenewal = 12,
        // PedigreeOrder = 13,
      ]
    };
  },
  created: function () {
    if(this.userInfo){
      personService
        .getMyPayments(this.userInfo.personId)
        .then((res) => {
          this.payments = res;
        }).catch(this.$handleError);
    }
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
  },
  watch: {      
    userInfo: function (newVal: object) { 
      personService
        .getMyPayments(this.userInfo.personId)
        .then((res) => {
          this.payments = res;
        }).catch(this.$handleError);
    },
  },
});
</script>
